import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const UnmarkItemAsCompletedDialog = ({ specialistId, curriculumItemId, fetchModules }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      specialistRequests.updateSpecialistCurriculumItemCompletions(specialistId, curriculumItemId),
      null,
      "DELETE",
    );
    notify("Успешен отказ на завършване на темата", { type: "success" });
    fetchModules();
    refresh();
  };
  return (
    <ConfirmModal
      titleContent={"Откажи завършването на темата"}
      onConfirm={handleSubmit}
      message="Сигурни ли сте, че искате да откажете завършването на темата?"
      triggerButton={
        <Button
          label="Откажи завършване"
          variant="contained"
          color="error"
          startIcon={<UnpublishedIcon />}
        />
      }
    />
  );
};

export default UnmarkItemAsCompletedDialog;
